
import { priceType } from "@/interFace/courses/types";
import Cookies, { set } from 'js-cookie';

const EuEuroCountries = [
  "AT",
  "BE",
  "HR",
  "CY",
  "EE",
  "FI",
  "FR",
  "DE",
  "GR",
  "IE",
  "IT",
  "LV",
  "LT",
  "LU",
  "MT",
  "NL",
  "PT",
  "SK",
  "SI",
  "ES",
];

export function GetPrice(
  prices?: priceType[] | undefined,
  isoCode: string | null = null
): priceType {
  if (!prices || prices.length === 0) {
    return {
      currencySymbol: "",
      price: 0,
      oldPrice: 0,
      discountPercentage: 0,
      isoCode: "",
    } as priceType;
  }

  if (!isoCode || isoCode === "") {
    isoCode = Cookies.get("isoCode") ?? "GB"; // Default to "GB" if no isoCode is provided
  }

  let filter = '';
  
  if(EuEuroCountries.includes(isoCode.toUpperCase())) {
    filter = "EU";
  }
  else if (isoCode.toUpperCase() === "CH") {
    filter = "CH";
  } else {
    filter = "GB"; // Default to "GB" for other countries
  }

  const filteredPrices = prices.filter((price) => price.isoCode === filter);
  const price = filteredPrices[0];

  if (price.price === 0) {
    return {
      currencySymbol: "",
      price: 0,
      oldPrice: 0,
      discountPercentage: 0,
      isoCode: "",
    } as priceType;
  }

  return {
    currencySymbol: price.currencySymbol,
    price: price.price,
    oldPrice: price.oldPrice,
    discountPercentage: price.discountPercentage,
    isoCode: price.isoCode,
  } as priceType;
}

export function GetCurrencySymbol(currencyType: number): string {
  switch (currencyType) {
    case 0:
      return "€"; // Euro
    case 1:
      return "CHF"; // Swiss Franc
    case 2:
      return "$"; // US Dollar
    case 3:
      return "£"; // British Pound
    default:
      return "£"; // Default to empty string if no match
  }
}
export function GetCurrencySymbolFromCode(currencySymbol: string): string {
  switch (currencySymbol.toUpperCase()) {
    case "EUR":
      return "€"; // Euro
    case "CHF":
      return "CHF"; // Swiss Franc
    case "USD":
      return "$"; // US Dollar
    case "CAD":
      return "C$"; // Canadian Dollar
    case "GBP":
      return "£"; // British Pound
    default:
      return "£"; // Default to empty string if no match
  }
}

export function GetCurrencyCode(currencySymbol: string): string {
  switch (currencySymbol) {
    case "€":
      return "EUR"; // Euro
    case "CHF":
      return "CHF"; // Swiss Franc
    case "$":
      return "USD"; // US Dollar
    case "C$":
      return "CAD"; // Canadian Dollar
    case "£":
      return "GBP"; // British Pound
    default:
      return "GBP"; // Default to empty string if no match
  }
}